import {AbstractControl, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {merge, Observable} from "rxjs";
import {filter, map, switchMapTo} from "rxjs/operators";
import {AddSingleFormatToCartModel} from "../models/cart/add-single-format-to-cart.model";
import {ProductFormatModel} from "../models/product/product-format.model";
import {ObservableBaseForm} from "./observable-base.form";

export class AddSingleFormatToCartForm extends ObservableBaseForm<AddSingleFormatToCartModel> {
    public get quantity(): AbstractControl {
        return this.formInstance.get("quantity") as AbstractControl;
    }

    public get format(): AbstractControl {
        return this.formInstance.get("format") as AbstractControl;
    }

    public static createForm(formBuilder: FormBuilder, initialValues: AddSingleFormatToCartModel): AddSingleFormatToCartForm {
        const form = formBuilder.group({
            productId: formBuilder.control(initialValues.productId, Validators.required),
            quantity: formBuilder.control(initialValues.quantity, [Validators.min(1)]),
            format: formBuilder.control(initialValues.format, [Validators.required])
        });

        return new AddSingleFormatToCartForm(form, initialValues);
    }

    public constructor(
        formInstance: FormGroup,
        initialValues: AddSingleFormatToCartModel,
    ) {
        super(formInstance, initialValues);
    }

    public reset(): void {
        this.format.setValue(null, {emitEvent: false});
        this.quantity.setValue(1, {emitEvent: false});
    }

    public handleFormatsUpdate(availableFormats: Array<ProductFormatModel>): void {
        const formatId = parseInt(this.format.value, 10);
        const currentFormat = availableFormats.find(item => item.id === formatId);
        if (!currentFormat) {
            this.format.setValue(null);
        }
    }

    protected createChangeSubscription(): Observable<AddSingleFormatToCartModel> {
        return merge(
                this.format.valueChanges,
                this.quantity.valueChanges
            )
            .pipe(
                switchMapTo(this.formInstance.statusChanges
                    .pipe(filter(this.validate))
                ),
                map(status => this.getModel())
            );
    }
}
